import { combineReducers } from 'redux';
import {
  FETCH_MY_REFERRALS_REQUEST,
  FETCH_MY_REFERRALS_SUCCESS,
  FETCH_MY_REFERRALS_FAILURE,
} from '../constants/ActionTypes';

const selected = (
  state = { data: [], paging: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_MY_REFERRALS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_MY_REFERRALS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data.data,
        paging: action.data.data.paging,
      };
    case FETCH_MY_REFERRALS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const referrals = combineReducers({
  selected,
});

export default referrals;
